var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopupprevArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 0C55.851 0 72 16.149 72 36C72 55.851 55.851 72 36 72C16.149 72 0 55.851 0 36C0 16.149 16.149 0 36 0ZM24.879 38.121L39.879 53.121C40.464 53.706 41.232 54 42 54C42.768 54 43.5361 53.706 44.1211 53.121C45.294 51.948 45.294 50.052 44.1211 48.879L31.242 36L44.121 23.121C45.2939 21.948 45.2939 20.052 44.121 18.879C42.948 17.7061 41.052 17.7061 39.879 18.879L24.879 33.8791C23.706 35.052 23.706 36.948 24.879 38.121Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupprevArrow);
export default __webpack_public_path__ + "static/media/popupprevArrow.67c24880c44ff2a90d99b69a9de62744.svg";
export { ForwardRef as ReactComponent };